export class CurrentUserProfile {
    public name: string;
    public profileImageUrl: string;
}



// WEBPACK FOOTER //
// ./src/models/account/current.user.profile.ts